module.exports = __webpack_public_path__ + "fcc299e3fb9f654b70000fda23b4fedb.png";